module.exports = __webpack_public_path__ + "img/word.30ddb4a3.png";